module.exports = __webpack_public_path__ + "img/aurora.f04ca1d4.png";